import { render, staticRenderFns } from "./addEvnParam.vue?vue&type=template&id=2fc09516&scoped=true"
import script from "./addEvnParam.vue?vue&type=script&lang=js"
export * from "./addEvnParam.vue?vue&type=script&lang=js"
import style0 from "./addEvnParam.vue?vue&type=style&index=0&id=2fc09516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc09516",
  null
  
)

export default component.exports